/**
 * Tiny sessionStorage-backed cache for the public deals feed.
 *
 * Why: the /deals data changes slowly (admin-curated inventory). Re-fetching
 * on every homepage mount wastes RTT. We cache for `TTL_MS` per key.
 *
 * Why sessionStorage (not localStorage): we want fresh data after the user
 * closes the tab — admin inventory edits should not be cached for days.
 */
const TTL_MS = 5 * 60 * 1000; // 5 minutes
const PREFIX = 'acf_deals_';

const safeRead = (key) => {
  try {
    return sessionStorage.getItem(key);
  } catch {
    return null;
  }
};

const safeWrite = (key, value) => {
  try {
    sessionStorage.setItem(key, value);
  } catch {
    /* quota exceeded → silently skip caching */
  }
};

export const dealsCacheGet = (key) => {
  const raw = safeRead(PREFIX + key);
  if (!raw) return null;
  try {
    const { t, v } = JSON.parse(raw);
    if (Date.now() - t > TTL_MS) return null;
    return v;
  } catch {
    return null;
  }
};

export const dealsCacheSet = (key, value) => {
  safeWrite(PREFIX + key, JSON.stringify({ t: Date.now(), v: value }));
};

export const dealsCacheClear = () => {
  try {
    Object.keys(sessionStorage)
      .filter((k) => k.startsWith(PREFIX))
      .forEach((k) => sessionStorage.removeItem(k));
  } catch {
    /* ignore */
  }
};
